import React, { useState, useEffect, useRef, useMemo } from 'react';
import { productAPI, orderAPI, dealerAPI, analyticsAPI, exportAPI, transporterAPI, crmAPI, stockAPI, productionAPI, getFileUrl } from '../../api';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { LayoutDashboard, Package, ShoppingBag, Users, LogOut, Plus, Edit, Trash2, CheckCircle, Truck, Loader2, FileText, BarChart3, PackageCheck, DollarSign, Download, IndianRupee, Upload, ImageIcon, ArrowUpDown, Eye, CalendarClock, Pencil, ClipboardList, Undo2, Menu, X, UserRound, MessageCircle, ArrowLeft, Warehouse, Minus, Factory } from 'lucide-react';

// Button that fires action once on click, and auto-repeats while pressed (press-and-hold)
export const HoldRepeatButton = ({ onFire, children, ...props }) => {
  const timeoutRef = React.useRef(null);
  const intervalRef = React.useRef(null);

  const clearTimers = React.useCallback(() => {
    if (timeoutRef.current) { clearTimeout(timeoutRef.current); timeoutRef.current = null; }
    if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
  }, []);

  const start = (e) => {
    e.preventDefault();
    onFire();
    // After a short delay, start auto-repeating, then accelerate
    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(onFire, 120);
      // Accelerate after 2s
      setTimeout(() => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = setInterval(onFire, 50);
        }
      }, 2000);
    }, 400);
  };

  React.useEffect(() => () => clearTimers(), [clearTimers]);

  return (
    <Button
      type="button"
      onMouseDown={start}
      onMouseUp={clearTimers}
      onMouseLeave={clearTimers}
      onTouchStart={start}
      onTouchEnd={clearTimers}
      onTouchCancel={clearTimers}
      {...props}
    >
      {children}
    </Button>
  );
};

